import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { EntityProps, EntityState, removeEntity, setAllEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

import { FinParcours } from '../../models/fin-parcours.model';
import { FinParcoursService } from '../../services/fin-parcours.service';
import { v7 as uuidv7 } from 'uuid';
import { ToastrErrorComponent } from '@shared/components/toastr/toastr-error.component';
import { toast } from 'ngx-sonner';

export function avecMéthodesFinsParcours<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<FinParcours>>(),
      props: type<EntityProps<FinParcours>>(),
    },
    withMethods((store) => ({
      chargerFinsParcours: (state: { fins: FinParcours[] }) => patchState(store, setAllEntities(state.fins)),
      supprimerFinParcours: (idFinParcours: string) => patchState(store, removeEntity(idFinParcours)),
    })),
    withMethods((store, service = inject(FinParcoursService)) => ({
      charger: rxMethod<string>(
        pipe(
          switchMap((idRéférentiel) =>
            service.trouverTous(idRéférentiel).pipe(
              tapResponse({
                next: (result) => {
                  store.chargerFinsParcours({ fins: result.items });
                },
                error: (err) => {
                  console.error(err);
                  const toastrId = uuidv7();
                  toast.custom(ToastrErrorComponent, {
                    componentProps: {
                      message: `Un problème est survenu lors de la récupération des fins de parcours, contactez le support.`,
                      id: toastrId,
                    },
                    id: toastrId,
                  });
                },
              }),
            ),
          ),
        ),
      ),
      supprimer: rxMethod<string>(
        pipe(
          switchMap((idFinParcours) =>
            service.supprimer(idFinParcours).pipe(
              tapResponse({
                next: () => store.supprimerFinParcours(idFinParcours),
                error: (err) => {
                  console.error(err);
                  const toastrId = uuidv7();
                  toast.custom(ToastrErrorComponent, {
                    componentProps: {
                      message: `Un problème est survenu lors de la suppression d'une fin de parcours, contactez le support.`,
                      id: toastrId,
                    },
                    id: toastrId,
                  });
                },
              }),
            ),
          ),
        ),
      ),
    })),
  );
}
